<template>
  <footer class="footer">
    <FlexWrap>
      <section class="top-container container">
        <SuccessMessage />
        <h2 class="share-title">Deel dit verhaal</h2>
        <Share />
        <h2>Wat vond je van deze special?</h2>
        <Thumbs />
        <a href="https://surveys.enalyzer.com/?pid=k4mur5hu">
          <Button class="button">
            stuur feedback
          </Button>
        </a>
      </section>
      <section class="colofon container">
        <Content>
          <h2>Colofon</h2>
          <h3>Redactie</h3>
          <p>
            Roel van Niekerk, Erika de Joode, Melvin Captein
          </p>
          <h3>Design &amp; code:</h3>
          <p><a href="https://defigners.nl/" target="_blank">Vincent Wielders</a>, <a href="https://robbertlokhorst.nl/" target="_blank">Robbert Lokhorst</a>, Tim van Steenbergen</p>
          <h3>Verantwoording</h3>
          <p>Alle informatie in deze special is gebaseerd op literatuuronderzoek en informatie van verschillende experts. Dank aan Ron de Jong, Henk van der Kolk, Alfred Moest, Ellen Dukker, Nick Bos, Bas van Leeuwen, Jan Luiten van Zanden, Henk Vording, Centraal Bureau voor de Statistiek, Kiesraad, Kadaster, UvA Tekstbank, Staten-Generaal Digitaal, Delpher/KB, Internationaal Instituut voor Sociale Geschiedenis, Nederlands Instituut voor Beeld en Geluid, De Nederlandse Grondwet.</p>
          <p>Gegevens over het aantal kiesgerechtigden in 1815 komen uit het proefschrift van historicus Lodewijk Blok: Stemmen en kiezen. Het kiesstelsel in Nederland in de periode 1814-1850.</p>
          <p>Voor het beantwoorden van de vraag “hoeveel grond moet je tegenwoordig bezitten om bij de 10 procent grootste particuliere grondbezitters te horen” heeft het Kadaster de volgende analyse voor de NOS nieuwsredactie uitgevoerd. In afstemming met de NOS is besloten uit te gaan van alleen natuurlijke personen (particulieren), van de rechtsvorm “volledig eigendom” (dus bijvoorbeeld geen erfpacht of vruchtgebruik) en van alleen grondpercelen (dus geen grond onder bijvoorbeeld appartementencomplexen met meervoudig eigendom). Bij situaties waar een perceel in eigendom is van meerdere natuurlijke personen wordt uitgegaan van de belangrijkste rechthebbende. Hiervoor wordt onder meer gekeken naar het grootste aandeel in het recht. Met deze aanpak wordt een pragmatische selectie gemaakt die het best recht doet aan de beoogde selectie van eigendommen. Van alle natuurlijke personen die op 1 januari 2019 grondpercelen in vol eigendom hebben is het in de Basisregistratie Kadaster opgenomen perceelsoppervlak van alle eigendommen gesommeerd. De resultaten hiervan worden geordend op basis van totaal oppervlakte van percelen, beginnende bij het subject met de meeste grond. Om de grens van 10 procent te berekenen wordt gekeken naar het totaal aantal subjecten die er zijn met een of meerdere percelen op naam. Wanneer de eerste 10 procent van alle subjecten wordt genomen ontstaat de lijst met subjecten met kiesrecht. De drempelwaarde om te mogen stemmen blijkt een totale oppervlakte grond van 1441 vierkante meter.</p>
          <p>Cijfers over het aantal kiesgerechtigden eind negentiende eeuw komen uit een studie van de economisch historici Jan Luiten van Zanden en Arthur van Riel: Nederland 1780-1914. Staat, instituties en economische ontwikkeling. Uit datzelfde boek komen de gegevens over de maandelijkse uitgaven van een gemiddeld arbeidersgezin aan het einde van die eeuw.</p>
          <p>Voor informatie over de huur, het salaris, spaargeld en de diploma’s die je nodig had om na 1896 te mogen stemmen, hebben we de Kieswet van dat jaar geraadpleegd. Die is digitaal beschikbaar in de Tekstbank van de Universiteit van Amsterdam (collectie Nederlandsch Schoolmuseum). Je kunt de wet <a target="_blank" href="https://schoolmuseum.uba.uva.nl/bookid/LCSM_202880">hier</a> inzien.</p>
          <p>Om een indicatie te geven van het salaris dat je in 1896 minimaal nodig had om te mogen stemmen, hebben we gekeken naar de 4,2% hoogste salarissen van nu. In die tijd was namelijk 4,2% van de kiesgerechtigden een ‘loonkiezer’. Uit de inkomensverdeling van het CBS (2017) kunnen we aflezen dat 4,2% van de Nederlandse huishoudens een jaarinkomen bezit van meer dan tussen de 54.000 en 56.000 euro (vooral uit loon).</p>
          <p>Cijfers over de verhouding tussen ‘belastingkiezers’ en ‘aangiftekiezers’ komen uit het archief van het Centraal Bureau voor de Statistiek: Bijdragen tot de statistiek van Nederland. Nieuwe volgreeks. Kiezers-statistiek (1901-1913). Bij de groep aangiftekiezers hoorden de mannen die gingen stemmen omdat ze voldoende huur betaalden, genoeg salaris of spaargeld hadden of een bepaald diploma.</p>
        </Content>
      </section>
    </FlexWrap>
  </footer>
</template>

<script>
import { Content, FlexWrap } from '@/components/chapter'
import { Share, SuccessMessage } from './share'
import Thumbs from './thumbs'
import Button from '@/components/Button'
import { chapterMixin } from '@/mixins'

export default {
  name: 'Footer',
  mixins: [chapterMixin],
  components: {
    Content,
    Share,
    Thumbs,
    SuccessMessage,
    Button,
    FlexWrap
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: $c-dark;
  color: white;
}

.share-title {
  margin-top: 0;
}

.top-container {
  text-align: center;
}

h2 {
  font-size: 26px;
  line-height: $lh-heading;
  font-weight: $fw-bold;
  margin-bottom: 1em;
}

h3 {
  font-size: $fs-normal;
  font-weight: $fw-bold;
  line-height: $lh-heading;
  margin-bottom: 0;
}

.button {
  margin: 30px auto;
  border: 1px solid white;
  width: auto;
}

.colofon {
  margin-top: 20px;
}

.content p {
  margin-top: 0;

  a {
    color: white;
    text-decoration: none;
  }
}
</style>
